

import Event = createjs.Event;

export class BasicPaymentEvent extends Event {
    public static PAYMENT_HASH_CHANGED: string = "paymentHashChanged";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

